import type {
  DropdownChangeFn,
  DropdownProps,
} from '../../../components/Dropdown/Dropdown';

import Dropdown from '../../../components/Dropdown/Dropdown';

import useYjsField from '../../collaboration/useYjsField';
import { useFieldContext } from '../../form';
import { useFieldErrors } from '../../useFieldErrors';

const DropdownField = ({
  multiple,
  onFocus,
  onBlur,
  disabled,
  ...props
}: DropdownProps) => {
  const field = useFieldContext();
  const errors = useFieldErrors(field.name);
  const yjsField = useYjsField(multiple ? 'array' : 'string');

  const onChange: DropdownChangeFn = (e) => {
    const value = e.target.value ?? '';
    field.handleChange(value);
    yjsField.update(value);
  };

  const onFieldFocus = () => {
    onFocus?.();
    yjsField.onFocus();
  };

  const onFieldBlur = () => {
    onBlur?.();
    field.handleBlur();
    yjsField.onBlur();
  };

  return (
    <Dropdown
      {...props}
      multiple={multiple}
      name={field.name}
      value={field.state.value}
      onChange={onChange}
      error={errors}
      onFocus={onFieldFocus}
      onBlur={onFieldBlur}
      disabled={disabled || yjsField.isBeingEdited}
      editors={yjsField.fieldEditors}
    />
  );
};

export default DropdownField;
